import React, { useState, useEffect } from 'react';

import { FullContactForm } from './FullContactForm';

import contactBg from '../../../main/assets/images/auvsi/contact.background-section.webp';
import contactTabletBg from '../../../main/assets/images/auvsi/contact-background-section-tablet.webp';
import contactMobileBg from '../../../main/assets/images/auvsi/contact-background-section-mobile.webp';

export const ContactBackgroundImage = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  let currentBg = contactBg;
  if (windowWidth <= 1200) {
    currentBg = contactTabletBg;
  }
  if (windowWidth <= 834) {
    currentBg = contactMobileBg;
  }

  return (
    <img
      src={currentBg}
      alt=""
      className="auvsi-contact-image"
      style={{
        minWidth: '100%',
        objectFit: 'cover',
        marginTop: '40px',
      }}
    />
  );
};

export const Contact = () => {
  return <FullContactForm />;
};
